<template>
  <div class="signin">
    <div class="container">
      <div class="columns is-mobile">
        <div class="column">
          <h1 class="is-size-2">The Timber Lounge</h1>
        </div>
      </div>
      <div class="columns is-mobile">
        <div class="column">
          <p class="is-size-4">Welcome {{ userNameDisplay }}!</p>
          <p v-if="locationPicked != ''">{{ locationPicked  }}</p>
          <p v-if="current_day != '' && !showLocationPicker && !showDatePicker">{{ currentDayDisplay }}</p>
        </div>
      </div>

      <div v-if="showLocationPicker" class="box signin-box">
        <div class="columns is-mobile">
          <div class="column is-12">
            <span class="is-size-3">1. Pick your Location:</span>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column is-12">
            <div class="select is-rounded">
              <select @change="setLocation()" v-model="locationPicked" style="font-size: 20pt;">
                <option>...</option>
                <option>Dartmouth</option>
                <option>Moncton</option>
                <option>Barrington</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showDatePicker" class="box signin-box">
        <span class="is-size-3">2. Pick your date:</span>
        <br/>
        <span class="is-size-4 has-text-weight-bold">{{ currentDayDisplay }}</span>
        <br/>
        <input type="date" @change="onDateChange($event)" 
            v-model="current_day" style="font-size: 20pt;"/>
        <br/>
        <br/>
        <button class="button is-primary" @click="setDate">SELECT</button>
      </div>

      <div v-if="showTeamPicker" class="box signin-box">
        <div class="columns is-mobile">
          <div class="column is-12">
            <p class="is-size-2">3. Pick your team:</p>
            <div v-show="pleaseWait">
              <div class="blink is-size-5 please-wait"><p>Please wait, loading data...</p></div>
            </div>
            <div v-show="!pleaseWait">
              <div v-if="booking_data.length === 0"><p class="is-size-4">no bookings found</p></div>
            </div>
            <div v-for="(throw_day, index) in booking_data" :key="index">
              <div v-for="lane in throw_day.bookings.lanes" :key="lane.id">
                <div v-for="team in lane.teams" :key="team.id">
                  <div v-if="team.team != ''" class="box" style="margin-bottom: 6px;">
                    <div class="columns">
                      <div class="column is-2">
                        <span class="is-size-3">{{ lane.lane }}</span>
                      </div>  
                      <div class="column is-2">
                        <span class="is-size-3">{{ team.time_slot }}</span>
                      </div>  
                      <div class="column is-6">
                        <span class="is-size-3">{{ team.team }}</span>
                      </div>  
                      <div class="column is-2">
                        <span>
                          <button class="button is-primary" @click="setTeam(lane.id, team.id, team.team, team.timeslot_guid, team.time_slot)">SELECT</button>
                        </span>
                      </div>  
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showWaiver" class="box signin-box">
        <div class="columns is-mobile">
          <div class="column is-12">
            <span class="is-size-2">4. Waiver</span>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column is-12">
            <p class="is-size-4">THE TIMBER LOUNGE WAIVER</p>
            <br/>
            <p class="is-size-4">TO: THE OWNER OF THE TIMBER LOUNGE and its employees, agents, successors, assigns 
            (all of whom are referred in this document together as the “Management”)</p>
            <br/>
            <p class="is-size-4">PLEASE READ CAREFULLY.</p>
            <br/>
            <p class="is-size-4">BY SIGNING THIS DOCUMENT YOU WILL:</p>
            <br/>
            <ul>
              <li>- WAIVE CERTAIN LEGAL RIGHTS, INCLUDING THE RIGHT TO SUE.</li>
              <li>- RELEASE OF THE TIMBER LOUNGE FROM LEGAL LIABILITY AND CLAIMS.</li>
              <li>- AGREE TO REIMBURSE THE TIMBER LOUNGE FOR LOSS OR DAMAGE</li>
              <li>- AGREE TO ASSUME RISK OF USING THE FACILITIES. </li>
            </ul>
            <br/>
            <p class="is-size-4">
              In return for allowing me to use the axe throwing equipment facilities (the “Facilities”) 
              and/or to participate in the axe throwing programs, leagues, and other services offered 
              at the Facilities, including, but not limited to, ace throwing, functions, and special events 
              (referred to in this document together as “Activities”), I hereby agree as follows:
            </p>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column is-6 has-text-left">
            <button class="button is-primary" @click="setWaiver">
              <span class="is-size-3 has-text-weight-bold">I AGREE</span>
            </button>
          </div>
            <div class="column is-6 has-text-right">
            <button class="button is-warning" @click="reset">
              <span class="is-size-3 has-text-weight-bold">CANCEL</span>
            </button>
          </div>
        </div>
      </div>

      <div v-if="showFinish" class="box signin-box">
        <div v-if="already_booked == true">
          <p class="is-size-3">You have already registered for this game. You're all set!</p>
        </div>
        <div v-else>
          <p class="is-size-3">Thanks for registering, you're all set!</p>
        </div>
        <br/>
        <p class="is-size-4">{{ $auth.user.name }}</p>
        <div style="color: white;">
          <p>{{ locationPicked  }}</p>
          <p>{{ currentDayDisplay }}</p>
          <p>{{ teamPicked }}</p>
          <p>Lane {{ lane }} {{ timeSlot }}</p>
          <p>Electronically signed [{{ waiver_guid  }}]</p>
        </div>
        <br/>
        <button class="button is-primary" @click="gotoHome()">Home</button>
        <br/>
      </div>

      <br/>
      <button class="button is-warning" @click="reset">RESET</button>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from "axios";
import {v4 as uuidv4} from 'uuid';

export default {
  name: 'signin',
  components : {
  },
  computed: {
    userNameDisplay() {
      if (this.$auth.user.name.indexOf("@") == -1) {
        return this.$auth.user.name;
      } else if (this.$auth.user.nickname != "") {
        return this.$auth.user.nickname;
      } else {
        return this.$auth.user.email;
      }
    },
    currentDayDisplay() {
      this.update_computed;
      if (this.current_day != null && this.current_day != "") {
        return moment(this.current_day).local().format('MMMM Do YYYY');
      } else {
        return "";
      }
    }
  },
  data () {
    return {
      debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
      publicPath: process.env.BASE_URL,
      errorMessage: '',
      showError: false,
      pleaseWait: true,
      booking_data: [],
      waiver_guid: null,

      /* work-flow */
      current_day: '',
      showLocationPicker: true,
      locationPicked: '',
      showTeamPicker: false,
      teamPicked: '',
      timeSlot: '',
      lane: '',
      showDatePicker: false,
      showWaiver: false,
      showFinish: false,
      update_computed: 0,
      already_booked: false
    }
  },
  methods:{
    gotoHome: function() {
      window.location.href = "https://www.axes2.ca";
    },
    setDate: function() {
      this.showDatePicker = false;
      this.showTeamPicker = true;

      this.booking_data = [];
      
      this.getBookingsByDate(this.current_day);
    },
    onDateChange: function(event) {
      this.current_day = event.target.value;
      this.update_computed++;
      return false;
    },
    setLocation: function() {
      this.showLocationPicker = false;
      this.showDatePicker = true;
    },
    setTeam: function(lane_id, team_id, team_name, timeslot_guid, timeslot) {
      this.teamPicked = team_name;
      this.timeSlot = timeslot;
      this.lane = lane_id;

      //get the authenticated user
      var user = this.$auth.user;

      //build a new structure with the game info and user info
      //timeslot_guid will be used to connect players and teams (games)
      var userWaiver = {
        "waiver_signed" : false,
        "location" : this.locationPicked,
        "lane_id" : lane_id,
        "team_id" : team_id,
        "team_name" : team_name,
        "timeslot" : timeslot,
        "timeslot_guid" : timeslot_guid,
        "user" : user,
        "datetimestamp": null
      };

      this.userWaiver = userWaiver;

      this.showTeamPicker = false;
      this.showWaiver = true;
    },
    setWaiver() {
      this.pleaseWait = true;

      this.userWaiver.waiver_signed = true;
      this.userWaiver.datetimestamp = new Date().toISOString();
      this.userWaiver.waiver_guid =  uuidv4();

      var url = (this.debugMode ? "http://localhost:8080/signin" : "https://axes2api.azurewebsites.net/signin")
      var token = this.$parent.getApiToken();

      axios.post(url, 
        {
          signin: this.userWaiver
        },
        {
          headers: {
              authorization: token
            }
        }
      )
      .then((response) => {
        if (response.data.error != null) {
          this.errorMessage = response.data.error;
          this.showError = true;
          this.pleaseWait = false;
        } else {
          this.showWaiver = false;
          this.showFinish = true;

          if (response.data.ops &&  response.data.ops[0]) {
            this.waiver_guid = response.data.ops[0].waiver_guid;
            this.already_booked = false;
          } else {
            this.waiver_guid = response.data.waiver_guid;
            this.already_booked = true;
          }

          this.pleaseWait = false;
        }
      }, (error) => {
        this.errorMessage = error;
        this.showError = true;
        this.pleaseWait = false;
      });
    },
    getBookingsByDate: function (daydate) {
      var url = (this.debugMode ? "http://localhost:8080/bookings/" : "https://axes2api.azurewebsites.net/bookings/")
      url += daydate;

      url += "/" + this.locationPicked;

      var token = this.$parent.getApiToken();

      this.pleaseWait = true;
      this.booking_data = [];

      axios.get(url,{
          headers: {
              authorization: token
          }
      })
        .then((response) => {
          if (response.data.error != null) {
            this.errorMessage = response.data.error;
            this.showError = true;
            this.pleaseWait = false;
          } else {
            if (response.data.length === 0) {
              this.booking_data = [];
            } else {
              this.booking_data = response.data; 
            }
            this.pleaseWait = false;
          }
        }, (error) => {
          this.errorMessage = error;
          this.showError = true;
          this.pleaseWait = false;
        });
    },
    reset: function() {
      this.showError = false;
      this.showFinish = false;
      this.showLocationPicker = true;
      this.locationPicked = "";
      this.showTeamPicker = false;
      this.showWaiver = false;
      this.teamPicked = false;
      this.timeSlot = "";
      this.current_day = "";
    }
  },
  mounted(){
    //
    console.log(this.$auth);
    //
    this.reset();
    //
    var today = moment(new Date()).local().format('YYYY-MM-DD');
    this.current_day = today;
    //
  }
}
</script>

<style lang="scss">
.signin {
  font-family: arial;
  color: goldenrod;
  background-color: black;

}
.signin-box {
  color: goldenrod;
  background: #505050;
  min-height: 300px;
}
</style>